import { mdiArrowLeft } from '@mdi/js';
import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderButton from '../components/layout/HeaderButton';
import CredentialOfferList from '../features/credential/CredentialOfferList';
import Layout from '../components/layout/Layout';

/**
 * @description Wallet offers page component
 * @return {React.FC}
 */
const WalletOffers: React.FC<PropsWithChildren> = () => {
  const navigate = useNavigate();
  return (
    <Layout
      title="Credential Offers"
      leftButton={<HeaderButton icon={mdiArrowLeft} onPress={() => navigate('/')}></HeaderButton>}
      scrollViewProps={{
        minHeight: '100%'
      }}>
      <CredentialOfferList />
    </Layout>
  );
};

export default WalletOffers;
